export default __webpack_public_path__ + "static/media/notification.25d097a7.svg";